<template>
  <SearchInternetCafes/>
</template>
<script>
import SearchInternetCafes from 'operations/inspection/searchInternetCafes.vue'
export default {
    components:{
      SearchInternetCafes
    }
}
</script>